import Context from './context';

export default Context.Consumer;
